/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPoolsAppletRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {GetPoolsAppletResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const getPoolsApplet = (request: GetPoolsAppletRequest, options?: CashRequestOptions) => post<GetPoolsAppletRequest, GetPoolsAppletResponse>("/2.0/cash/get-pools-applet", request, {...options, rejectOnError: true })